import React from "react";
import { Button } from "../button/button";
import { ReactNode, useState } from "react";
import "./feedback-card.scss";

export type FeedbackCondition = "met" | "not-met";

export interface FeedbackCardProps {
  summaryText: string;
  condition?: FeedbackCondition;
  improvementText?: string;
  onSave?: (improvementText: string, condition: FeedbackCondition) => void;
  onCancel?: () => void;
  defaultOpen?: boolean;
  children?: ReactNode;
}

const FeedbackCard = ({
  summaryText,
  condition = "met",
  improvementText = "",
  onSave,
  onCancel,
  defaultOpen = false,
  children,
}: FeedbackCardProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleOpen = () => setIsOpen(true);

  const handleSave = () => {
    onSave?.(improvementText, condition);
    setIsOpen(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setIsOpen(false);
  };

  if (!isOpen) {
    return (
      <div className="feedback-card">
        <div className="feedback-card__row">
          <div className="feedback-card__summary">{summaryText}</div>
          <button
            type="button"
            onClick={handleOpen}
            className="feedback-card__edit-btn"
          >
            Edit
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-card">
      {children}

      <div className="feedback-card__actions">
        <Button
          buttonType="primary"
          size="small"
          onClick={handleSave}
          disabled={false}
        >
          Save
        </Button>
        <Button
          buttonType="secondary"
          size="small"
          onClick={handleCancel}
          disabled={false}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export { FeedbackCard };
export default FeedbackCard;
